export class EncroachmentActionDto {
  EncroachmentActionId: string;
  EncroachmentActionName: string;
  EncroachmentActionDate: string;
  Remarks: string;
  CreatedPerson: string;
  EncroachmentHistoryId: string;
  SubscriberId: string;
  SubscriptionUserId: string;
  Description: string;
  id: string;
  PipelineEncroachmentId: string;
}
